import { Component } from '@angular/core';

@Component({
  selector: 'app-unauth',
  templateUrl: './unauth.component.html',
  styleUrls: ['./unauth.component.scss'],
  standalone: false,
})
export class UnauthComponent {
  constructor() {}
}
